/* eslint-disable no-param-reassign */
const state = {
  event: {},
  allProducts: [],
  products: [],
  deliveryPickUpEvent: {},
  deliveryPickUpOrderId: '',
  deliveryDetails: {},
  pickupFee: null, // instance of PickupFee
  startDate: '',
  startTime: '',
  startTimeObj: {},
  userInfo: {},
  repetitionFrequency: 1,
  shoppingListName: '',
  selectedPaymentMethod: {},
};

const mutations = {
  setEvent(localState, event) {
    localState.event = {};
    if (event != null) {
      localState.event = { ...event };
    }
  },
  setAllProducts(localState, allProducts) {
    localState.allProducts = [];
    if (allProducts != null) {
      localState.allProducts = [...allProducts];
    }
  },
  setProducts(localState, products) {
    localState.products = [];
    if (products != null) {
      localState.products = [...products];
    }
  },
  setDeliveryPickUpEvent(localState, deliveryPickUpEvent) {
    localState.deliveryPickUpEvent = {};
    if (deliveryPickUpEvent != null) {
      localState.deliveryPickUpEvent = { ...deliveryPickUpEvent };

      if (
        deliveryPickUpEvent.Type !== 'Delivery' &&
        deliveryPickUpEvent.Type !== 'Shiplee'
      ) {
        localState.deliveryPrice = 0;
      }
    }
  },
  setDeliveryPickUpOrderId(localState, orderId) {
    localState.deliveryPickUpOrderId = orderId;
  },
  setDeliveryDetails(localState, details) {
    localState.deliveryDetails = {};
    if (details != null) {
      localState.deliveryDetails = { ...details };
    }
  },
  setPickupFee(localState, feeObj) {
    localState.pickupFee = feeObj;
  },
  setStartDate(localState, startDate) {
    localState.startDate = startDate;
  },
  setStartTime(localState, startTime) {
    localState.startTime = startTime;
  },
  setStartTimeObj(localState, startTimeObj) {
    localState.startTimeObj = {};
    if (startTimeObj != null) {
      localState.startTimeObj = { ...startTimeObj };
    }
  },
  setUserInfo(localState, userInfo) {
    localState.userInfo = {};
    if (userInfo != null) {
      localState.userInfo = { ...userInfo };
    }
  },
  setRepetitionFrequency(localState, repetitionFrequency) {
    localState.repetitionFrequency = repetitionFrequency;
  },
  setShoppingListName(localState, shoppingListName) {
    localState.shoppingListName = shoppingListName;
  },
  setSelectedPaymentMethod(localState, selectedPaymentMethod) {
    localState.selectedPaymentMethod = selectedPaymentMethod;
  },
  clear(localState) {
    localState.shoppingListName = '';
    localState.repetitionFrequency = 1;
    localState.userInfo = {};
    localState.startTimeObj = {};
    localState.startTime = '';
    localState.startDate = '';
    localState.deliveryPickUpOrderId = '';
    localState.deliveryPickUpEvent = {};
    localState.products = [];
    localState.allProducts = [];
    localState.event = {};
    localState.selectedPaymentMethod = {};
  },
};
const getters = {
  event(localState) {
    return localState.event;
  },
  allProducts(localState) {
    return localState.allProducts;
  },
  products(localState) {
    return localState.products;
  },
  deliveryPickUpEvent(localState) {
    return localState.deliveryPickUpEvent;
  },
  deliveryPickUpOrderId(localState) {
    return localState.deliveryPickUpOrderId;
  },
  deliveryDetails(localState) {
    return localState.deliveryDetails;
  },
  pickupFee(localState) {
    return localState.pickupFee;
  },
  startDate(localState) {
    return localState.startDate;
  },
  startTime(localState) {
    return localState.startTime;
  },
  startTimeObj(localState) {
    return localState.startTimeObj;
  },
  userInfo(localState) {
    return localState.userInfo;
  },
  repetitionFrequency(localState) {
    return localState.repetitionFrequency;
  },
  shoppingListName(localState) {
    return localState.shoppingListName;
  },
  selectedPaymentMethod(localState) {
    return localState.selectedPaymentMethod;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
